import { NgModule } from '@angular/core';
import { ReinforcementsService } from '../../reinforcements/reinforcements.service';
import { MeasurementsService } from './measurements.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DimensionsService } from './dimensions.service';
import { ConstructionLimitationService } from './construction-limitation.service';

@NgModule({
    imports: [CommonModule, FormsModule],
    exports: [],
    declarations: [],
    providers: [ReinforcementsService, MeasurementsService, ConstructionLimitationService, DimensionsService]
})
export class DimensionsModule {
    constructor() {}
}
